<template>
  <div class="register">
    <v-topBar :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' ></v-topBar>
    <v-registerTop :navTitle="navTitle"></v-registerTop>
    <!--<div class="setNavBg">-->
      <!--<v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' :paramInfo='paramInfo'></v-header>-->
    <!--</div>-->
    <div class="registerStepTit"><h3>供应商注册</h3></div>
    <div class="registerStepCon">
      <el-steps :active="3" align-center>
        <el-step title="1 填写企业信息"></el-step>
        <el-step title="2 完善个人信息"></el-step>
        <el-step title="3 提交审核"></el-step>
        <el-step title="4 完成注册"></el-step>
      </el-steps>
      <div class="examineCon">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/registerSuccess.png" alt="">
        <h5>注册成功</h5>
        <p>您已注册成功！</p>
      </div>
      <el-button @click="goToHref('/')">返回首页</el-button>
    </div>
    
    <v-footer  :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import registerTop from '@/components/registerTop'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      return {
        userAgreementVisible: false,
        privacyPolicyVisible: false,
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        navTitle:'注册',
        webConfigInfo: {},
        checkList:[],
        abroadShow:false
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-registerTop': registerTop,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
       this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
        }).then((res) => {
          this.data = res.data;
          this.webConfigInfo = this.data.webConfigInfoDto;
          this.footerColumnInfos = this.data.footerColumnInfos;
          this.navigationColumnInfos = this.data.navigationColumnInfos;
        }).catch((err) => {
          console.log(err)
        })
    },
    mounted () {
    },
    methods: {
      goToHref(val){
        this.$router.push({path: val})
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registerComplete/index.vue